<div>
  <app-nav-bar>
    <main class="container-main">
      <div class="row d-flex justify-content-between row-header-send">
        <div class="d-flex gap-8">
          <span class="screen-title">Importação de arquivo</span>
        </div>
      </div>

      <div class="card-filters">
        <div class="header-filter">
          <h5>Upload de arquivo</h5>
        </div>

        <div class="content-filter">
          <form [formGroup]="partnerDocumentForm">
            <div class="row">
              <div class="col">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Parceiro</mat-label>
                  <mat-select
                    formControlName="partnerId"
                    (selectionChange)="changePartner($event)"
                    required
                    #partnerSelect
                  >
                    <mat-option disabled class="search-option">
                      <ngx-mat-select-search
                        placeholderLabel="Pesquisar parceiro"
                        noEntriesFoundLabel="Nenhum resultado encontrado"
                        [formControl]="partnerFilterCtrl"
                      >
                      </ngx-mat-select-search>
                    </mat-option>

                    <mat-option
                      *ngFor="let p of filteredPartners | async"
                      [value]="p.code"
                    >
                      Ag {{ p.agencyNumber }} - {{ p.companyName }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      partnerDocumentForm.get('partnerId')?.hasError('required')
                    "
                  >
                    Parceiro obrigatório
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Arquivo do parceiro</mat-label>
                  <input
                    type="file"
                    hidden
                    #fileInput
                    (change)="onFileSelected($event); fileInput.value = ''"
                  />
                  <input
                    matInput
                    class="tappable"
                    [value]="selectedFileName"
                    placeholder="Selecione um arquivo"
                    readonly
                    (click)="fileInput.click()"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="buttons-filter">
              <button
                type="button"
                [style.width]="'134px'"
                class="btn-outline-dark btn"
                (click)="onClear()"
              >
                Limpar
              </button>

              <button
                class="btn btn-dark-primary-blue"
                type="button"
                (click)="onSubmit()"
                [disabled]="partnerDocumentForm.invalid || loading"
              >
                Enviar
                <span
                  class="spinner-border spinner-border-sm"
                  *ngIf="loading"
                ></span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="painel file-status">
        <p class="message-text">Status:</p>
        <p id="txt-error-order">
          {{ responseMsg }}
        </p>
      </div>
    </main>
  </app-nav-bar>
</div>
